import { SearchOutlined } from "@ant-design/icons";
import { Drawer, Tooltip } from "antd";
import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import LoadingBox from "../../../../components/LoadingBox";
import Header from "../../../../components/Popup/_components/Header";
import { UserService } from "../../../../util/services/user";
import { propsModal } from "../../../../util/varibles/constants";
import { showErrorResponse } from "../../../../util/varibles/global";
import { IChangeLog } from "../../../../util/varibles/interface";
import { SOCKET_FUNC, SOCKET_NAME } from "../../../../web-socket/constants";
import WSService, { IResultSocket } from "../../../../web-socket/web-socket-service";
import { selectPlan } from "../../constants";
import ChangeLogs from "./ChangeLogs";
import SearchBox from "./SearchBox";
import styles from './style.module.scss';

let socket: WSService | undefined;

interface IProps {
    onClose(): void
}

const PopupChangesLog: React.FC<IProps> = (props) => {
    const [visible, setVisible] = useState(true);
    const [data, setData] = useState<IChangeLog[]>([]);
    const [loadMore, setLoadMore] = useState(false);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState(false);
    const vessels = useSelector(selectPlan.vessels);
    const popupClose = useSelector(selectPlan.popupClose);
    const { onClose } = props;

    const handleClose = useCallback(() => {
        if (socket)
            socket.removeListener(SOCKET_NAME.POPUP);
        setVisible(false)
        onClose();
    }, [onClose]);

    const onKeyDown = useCallback((e: any) => {
        if (e.key === 'Escape') {
            handleClose()
        }
    }, [handleClose])

    function lazyLoading() {
        if (loading)
            return;
        const { timestamp } = data[data.length - 1] || {};
        getData(timestamp - 1);
    }

    const getData = useCallback((timestamp: number = Date.now()) => {
        setLoading(true);
        UserService.getUserLog({ timestamp })
            .then((rs: any) => {
                const { is_prev, logs = [] } = rs;
                setLoadMore(is_prev)
                setLoading(false);
                setData(prev => [...prev || [], ...logs]);
            })
            .catch(error => {
                setLoading(false);
                showErrorResponse('Get data failed', error)
            })
    }, [])

    const addByWs = useCallback((value: IResultSocket) => {
        if (value.function !== SOCKET_FUNC.CHANGES_LOG) return;

        setData(prev => [value.message, ...prev])
    }, []);


    useEffect(() => {
        getData()

        document.addEventListener('keydown', onKeyDown)

        return () => {
            document.removeEventListener('keydown', onKeyDown)
        }
    }, [getData, onKeyDown]);

    useEffect(() => {
        new WSService({ listener: { lev: SOCKET_NAME.POPUP, func: addByWs } })

        return () => {
            WSService.close(SOCKET_NAME.POPUP)
        };
    }, [addByWs]);

    useEffect(() => {
        if (popupClose)
            handleClose()
    }, [popupClose, handleClose]);

    const handleCloseSearch = useCallback((reload?: boolean) => {
        setSearch(false);
        if (reload) {
            setData([]);
            getData();
        }
    }, [getData])

    return <Drawer
        {...propsModal}
        open={visible}
        mask={false}
        title={<Header title={<div className='flex justify-between items-center gap-2'>
            <div>Changes log</div>
            <Tooltip title='Search by operation code'>
                <div className='bt-ghost' data-icon={true} onClick={() => setSearch(true)}>
                    <SearchOutlined />
                </div>
            </Tooltip>
        </div>} size='small' onClose={handleClose} />}
    >
        <SearchBox
            open={search}
            loading={loading}
            onClose={handleCloseSearch}
            onLoad={(code?: string) => {
                if (!code) {
                    return;
                }
                setData([]);
                setLoadMore(false);
                setLoading(true);
                UserService.getOpLog({ operation_code: code })
                    .then((rs: any) => {
                        const { logs = [] } = rs;
                        setLoading(false);
                        setData(logs);
                    })
                    .catch(error => {
                        setLoading(false);
                        showErrorResponse('Get data failed', error)
                    })
            }}
        />
        <ChangeLogs data={data} vessels={vessels} prev={loadMore} loadMore={lazyLoading} />
        {(data.length === 0 || loading) && <div className={styles.loading}>
            <LoadingBox loading={loading} />
        </div>}
    </Drawer>;
};


export default PopupChangesLog;
